<template>
   <div class="page magic-bg dark:text-white">
        <navigation :key="navigationKey"/>
        <div class="bookmark">
            <div class="bookmark-container">
                <div class="bookmark-modal" id="users_adjustments">
                    <div class="flex flex-row items-center justify-between mb-2">
                        <p class="bookmark-modal-title text-gradient mr-auto">Сортировка</p>
                        <button class="rounded-button" title="Очистить сортировку" @click="ClearParams">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 hover:animate-spin" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Поиск</label>
                        <input class="input sm:ml-2" type="text" v-model="search_param">
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Только операторы</label>
                        <input class="checkbox-toggle sm:ml-auto" type="checkbox" v-model="is_operator">
                    </div>
                    <p class="bookmark-modal-title text-gradient mr-auto">Инструменты</p>
                    <button class="mt-2 ml-2 mr-auto" @click="pageNumber = 0;GetData()">Запросить данные заново</button>
                </div>
            </div>
            <div class="bookmark-navbar">
                <div class="bookmark-link" @click="$root.ToggleBookmark('#users_adjustments')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                    </svg>
                </div>
            </div>
        </div>

        <div class="flex flex-row items-end justify-between mt-4 w-[90%] max-w-4xl mx-auto fade">
            <div class="flex flex-row items-center justify-center background rounded-t-lg ml-3 py-2 px-3 fade">
                <p>С</p>
                <p class="ml-2">{{pageNumber * elementNumber + 1}}</p>
                <p class="ml-2">по</p>
                <p class="ml-2">{{pageNumber * elementNumber + users.length}}</p>
                <p class="ml-2"><b class="text-gradient">Всего:</b> {{userCount}}</p>
            </div>
            <div class="flex flex-row items-center justify-center background rounded-t-lg mr-3 py-2 px-3 fade">
                <button @click="Back">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
                <p>{{pageNumber + 1}}</p>
                <p class="ml-2">из</p>
                <p class="ml-2">{{pagesCount}}</p>
                <button @click="Forward">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>

        <div class="card py-0 w-[90%] max-w-4xl mx-auto overflow-auto fade" style="max-height: calc(100vh - 10rem)">
            <table class="sys-table">
                <thead>
                    <th>№</th>
                    <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                    <th>ФИО</th>
                    <th class="w-6"></th>
                </thead>
                <tbody>
                    <tr v-for="(user, index) in users" :key="'u_'+index">
                        <th>{{pageNumber * elementNumber + index + 1}}</th>
                        <td class="text-center" v-if="$root.HasRole($store.state.adminRole)">{{user.id}}</td>
                        <td class="text-center">{{GetUserFIO(user)}}</td>
                        <th>
                            <button class="text-warning hover:animate-spin" @click="OpenUserConfiguration(index)" v-if="user.roles.includes($store.state.adminRole) && $root.HasRole($store.state.adminRole)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                                </svg>
                            </button>
                            <button class="text-warning hover:animate-spin" @click="OpenUserConfiguration(index)" v-if="!user.roles.includes($store.state.adminRole)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal dark:text-white" id="UserSettings" @click="$root.HideModal('#UserSettings')">
        <form class="modal-dialog" @submit="ChangeUserSettings" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Настройка пользователя</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#UserSettings')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
        <div class="modal-dialog-body" :style="currentUser !== null && IsOperator(users[currentUser]) ? 'min-height: 270px' : ''" v-if="currentUser !== null">
            <div class="flex flex-col my-2" v-if="IsOperator(users[currentUser])">
                <label class="input-label">Темы</label>
                <Multiselect
                    v-model="currentUserThemes"
                    class="mt-2"
                    ref="current_user_themes"
                    :options="$root.CreateSelectOptions(themes, 'title')"
                    mode="tags"
                    :canClear="false"
                    :searchable="true"
                    :close-on-select="false"
                    noResultsText="Ничего не найдено"
                    :classes="{
                        container: 'relative input flex items-center justify-end box-border cursor-pointer p-1 max-w-[400px] max-h-[100px] ml-2',
                        dropdown: 'max-h-40 absolute left-1 right-1 bottom-0 transform translate-y-full -mt-px overflow-y-scroll z-50 background-darker flex flex-col rounded-b',
                        dropdownHidden: 'hidden',
                        optionPointed: 'bg-black/5 dark:bg-white/5',
                        tagsSearch: 'absolute inset-0 border-0 outline-none appearance-none p-0 text-base box-border bg-transparent w-full',
                        noResults: 'py-2 px-3 text-secondary text-left',
                    }"
                >
                    <template v-slot:tag="{ option, handleTagRemove, disabled }">
                        <div class="multiselect-tag is-user gradient dark:!bg-gradient-to-tl max-w-[150px] md:max-w-xs lg:max-w-none break-words whitespace-normal" :class="{'is-disabled': disabled}">
                            {{ option.label }}
                            <span v-if="!disabled" class="multiselect-tag-remove" @click="handleTagRemove(option, $event)">
                                <span class="multiselect-tag-remove-icon"></span>
                            </span>
                        </div>
                    </template>
                    <template v-slot:option="{ option }">
                        {{ option.label }}
                    </template>
                </Multiselect>
            </div>
            <div class="flex flex-row justify-between items-center my-2" v-if="!(users[currentUser].roles.includes($store.state.adminRole) || users[currentUser].roles.includes($store.state.mainOperatorRole))">
                <label class="input-label">Сделать оператором</label>
                <input class="checkbox-toggle" type="checkbox" ref="toggleUserOperator" :checked="IsOperator(users[currentUser])">
            </div>
        </div>
        <div class="modal-dialog-footer">
            <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#UserSettings')">Закрыть</button>
            <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#UserSettings')">Применить</button>
        </div>
        </form>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation'

import Multiselect from '@vueform/multiselect'

export default {
    components: {
        Navigation,
        Multiselect
    },
    data() {
        return {
            socket: null,
            search_param: "",
            is_operator: false,
            elementNumber: 15,
            pageNumber: 0,
            userCount: 0,
            pagesCount: 0,
            navigationKey: "nav",
            title: "Контроль операторов",
            users: [],
            workers: {},
            operators: {},
            themes: {},
            currentUser: null,
            currentUserThemes: []
        }
    },
    methods: {
        SetTitle() {
            document.title = `Samgk Служба заботы - ${this.title}`
        },
        Forward() {
            this.pageNumber = this.pageNumber >= this.pagesCount - 1 ? 0 : this.pageNumber + 1
            this.GetData()
        },
        Back() {
            this.pageNumber = this.pageNumber <= 0 ? this.pagesCount - 1 : this.pageNumber - 1
            this.GetData()
        },
        ClearParams() {
            this.search_param = ""
            this.is_operator = false
        },
        async GetData() {
            this.$root.StartLoading()
            this.currentUser = null

            let res = await fetch(this.$store.state.supportApiAddr + `/v1.0/users/list?limit=${this.elementNumber}&skip=${this.pageNumber * this.elementNumber}&alphabetical=true&search=${this.search_param}&is_operator=${this.is_operator}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
                credentials: "include"
            })
            .then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            this.users = res.data.users
            this.workers = res.data.workers
            this.operators = res.data.operators

            this.userCount = res.data.count

            this.pagesCount = Math.ceil(this.userCount / this.elementNumber)

            res = await fetch(this.$store.state.supportApiAddr + `/v1.0/themes/list`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
                credentials: "include"
            })
            .then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            let themes = res.data.themes

            let themeList = {}

            themes.map((value)=>themeList[value.id] = value)

            this.themes = themeList

            this.$root.EndLoading()
        },
        OpenUserConfiguration(index) {
            this.currentUser = index

            let currentUser = this.users[this.currentUser]

            this.currentUserThemes = []

            if (this.IsOperator(currentUser)) this.currentUserThemes = this.operators[currentUser.id].themes

            this.$root.ShowModal("#UserSettings")
        },
        ChangeUserSettings(e) {
            e.preventDefault()

            let toggleUserOperator = this.users[this.currentUser].roles.includes(this.$store.state.adminRole) || this.users[this.currentUser].roles.includes(this.$store.state.mainOperatorRole) ? true : this.$refs.toggleUserOperator.checked

            fetch(this.$store.state.supportApiAddr + "/v1.0/users/operators/assign_access", {
                method: "PUT",
                headers: {
                    'Content-Type': 'text/json;charset=utf-8',
                    'Authorization': `Bearer ${this.$root.GetToken()}`
                },
                credentials: "include",
                body: JSON.stringify({
                    "id": this.users[this.currentUser].id,
                    "themes": this.currentUserThemes,
                    "operator": toggleUserOperator
                })
            })
            .then(response => response.json())
            .then(res=> {
                if (this.$root.HandleFetchError(res)) return

                this.$root.ShowToast("Настройки пользователя успешно изменены", "success")

                this.currentUser = null
                this.currentUserThemes = []

                this.GetData()
            })
        },
        GetUserFIO(user) {
            if (user.id in this.workers) {
                let worker = this.workers[user.id]

                return `${worker.surname} ${worker.name} ${worker.middle_name}`
            }

            return "Данных нет"
        },
        IsOperator(us) {
            if (!(us.id in this.operators)) return false

            if (us.roles.includes(this.$store.state.adminRole) || us.roles.includes(this.$store.state.mainOperatorRole) || us.roles.includes(this.$store.state.operatorRole)) {
                if (this.operators[us.id].themes === null ) this.operators[us.id].themes = []

                return true
            }

            return false 
        },
        AddTheme(theme) {
            this.themes[theme.id] = theme
        },
        RemoveTheme(theme) {
            delete this.themes[theme.id]
        },
        async StartWebsocket() {
            if (this.$route.name !== "Control" || this.socket !== null || !this.$root.IsServiceEnabled()) return

            let socket = new WebSocket(this.$store.state.wsAddr + "/v1.0/ws")

            let ShowToast = this.$root.ShowToast
            let token = this.$root.GetWSAuthData()

            let AddTheme = this.AddTheme
            let RemoveTheme = this.RemoveTheme

            socket.onopen = () => {
                socket.send(token)
            }

            socket.onmessage = function(event) {
                let data = JSON.parse(event.data)

                switch (data.type) {
                    case "new_theme":
                        AddTheme(data.data)
                        break;
                    case "updated_theme":
                        AddTheme(data.data)
                        break;
                    case "removed_theme":
                        RemoveTheme(data.data)
                        break;
                }
            }

            socket.onclose = () => {setTimeout(() => {this.StartWebsocket()}, 10000)}

            socket.onerror = function(event) {
                ShowToast("Не удалось установить соединение с сервером. Подгрузка данных в реальном времени невозможна", "warning")
            }

            this.socket = socket
        },
    },
    beforeUnmount() {
        if (this.socket !== null) this.socket.close()
    },
    mounted() {
        if (this.$root.fatal) return
        this.SetTitle()
        this.$root.StartLoading()
        this.$root.UpdateToken()
        this.$root.GetRoles().then(()=>{
            this.$root.EndLoading()
            if (!(this.$root.HasRole(this.$store.state.adminRole) || this.$root.HasRole(this.$store.state.mainOperatorRole))) {
                setTimeout( () => { this.$root.ShowToast("У вас нет прав на посещение данного раздела", "error", 8000) }, 1000 )
                this.$router.push({name: 'Home'})
                return
            }

            this.GetData()

            setTimeout(()=> {
                this.$root.StartWebsocket()
                this.StartWebsocket()
            }, 100)
        })
    }
}
</script>